// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WeatherRouteImport } from './routes/weather'
import { Route as TravelTipsRouteImport } from './routes/travel-tips'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SubmitReviewRouteImport } from './routes/submit-review'
import { Route as SubmitPhotoRouteImport } from './routes/submit-photo'
import { Route as ShopRouteImport } from './routes/shop'
import { Route as RlsCheckRouteImport } from './routes/rls-check'
import { Route as ReviewsRouteImport } from './routes/reviews'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as MyStayRouteImport } from './routes/my-stay'
import { Route as LinksRouteImport } from './routes/links'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as FishingReportRouteImport } from './routes/fishing-report'
import { Route as FishingRouteImport } from './routes/fishing'
import { Route as FishSpeciesRouteImport } from './routes/fish-species'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as CartRouteImport } from './routes/cart'
import { Route as BookingRouteImport } from './routes/booking'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AccommodationsRouteImport } from './routes/accommodations'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as ShopProductIdRouteImport } from './routes/shop_.$productId'
import { Route as MyStayInvoiceRouteImport } from './routes/my-stay_.invoice'
import { Route as DisplayWeatherRouteImport } from './routes/display.weather'
import { Route as DisplayTidesRouteImport } from './routes/display.tides'
import { Route as DevTypographyRouteImport } from './routes/dev.typography'
import { Route as DevSeoDebugRouteImport } from './routes/dev.seo-debug'
import { Route as DevSentryTestRouteImport } from './routes/dev.sentry-test'
import { Route as CheckoutReturnRouteImport } from './routes/checkout_.return'
import { Route as AdminLoginRouteImport } from './routes/admin_.login'
import { Route as AuthenticatedReportConditionsRouteImport } from './routes/_authenticated/report-conditions'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'
import { Route as AuthenticatedAdminTeamRouteImport } from './routes/_authenticated/admin.team'
import { Route as AuthenticatedAdminStaysRouteImport } from './routes/_authenticated/admin.stays'
import { Route as AuthenticatedAdminStaffingRouteImport } from './routes/_authenticated/admin.staffing'
import { Route as AuthenticatedAdminReviewsRouteImport } from './routes/_authenticated/admin.reviews'
import { Route as AuthenticatedAdminProfileRouteImport } from './routes/_authenticated/admin.profile'
import { Route as AuthenticatedAdminPayoutsRouteImport } from './routes/_authenticated/admin.payouts'
import { Route as AuthenticatedAdminInboxRouteImport } from './routes/_authenticated/admin.inbox'
import { Route as AuthenticatedAdminGuestReviewsRouteImport } from './routes/_authenticated/admin.guest-reviews'
import { Route as AuthenticatedAdminFishingRouteImport } from './routes/_authenticated/admin.fishing'
import { Route as AuthenticatedAdminEmailStatusRouteImport } from './routes/_authenticated/admin.email-status'
import { Route as AuthenticatedAdminDashboardRouteImport } from './routes/_authenticated/admin.dashboard'
import { Route as AuthenticatedAdminCalendarRouteImport } from './routes/_authenticated/admin.calendar'
import { Route as AuthenticatedAdminBookingsRouteImport } from './routes/_authenticated/admin.bookings'
import { Route as AuthenticatedAdminActivityRouteImport } from './routes/_authenticated/admin.activity'

const WeatherRoute = WeatherRouteImport.update({
            id: '/weather',path: '/weather',getParentRoute: () => rootRouteImport
          })
const TravelTipsRoute = TravelTipsRouteImport.update({
            id: '/travel-tips',path: '/travel-tips',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SubmitReviewRoute = SubmitReviewRouteImport.update({
            id: '/submit-review',path: '/submit-review',getParentRoute: () => rootRouteImport
          })
const SubmitPhotoRoute = SubmitPhotoRouteImport.update({
            id: '/submit-photo',path: '/submit-photo',getParentRoute: () => rootRouteImport
          })
const ShopRoute = ShopRouteImport.update({
            id: '/shop',path: '/shop',getParentRoute: () => rootRouteImport
          })
const RlsCheckRoute = RlsCheckRouteImport.update({
            id: '/rls-check',path: '/rls-check',getParentRoute: () => rootRouteImport
          })
const ReviewsRoute = ReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const MyStayRoute = MyStayRouteImport.update({
            id: '/my-stay',path: '/my-stay',getParentRoute: () => rootRouteImport
          })
const LinksRoute = LinksRouteImport.update({
            id: '/links',path: '/links',getParentRoute: () => rootRouteImport
          })
const GalleryRoute = GalleryRouteImport.update({
            id: '/gallery',path: '/gallery',getParentRoute: () => rootRouteImport
          })
const FishingReportRoute = FishingReportRouteImport.update({
            id: '/fishing-report',path: '/fishing-report',getParentRoute: () => rootRouteImport
          })
const FishingRoute = FishingRouteImport.update({
            id: '/fishing',path: '/fishing',getParentRoute: () => rootRouteImport
          })
const FishSpeciesRoute = FishSpeciesRouteImport.update({
            id: '/fish-species',path: '/fish-species',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CheckoutRoute = CheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => rootRouteImport
          })
const CartRoute = CartRouteImport.update({
            id: '/cart',path: '/cart',getParentRoute: () => rootRouteImport
          })
const BookingRoute = BookingRouteImport.update({
            id: '/booking',path: '/booking',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AccommodationsRoute = AccommodationsRouteImport.update({
            id: '/accommodations',path: '/accommodations',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const ShopProductIdRoute = ShopProductIdRouteImport.update({
            id: '/shop_/$productId',path: '/shop/$productId',getParentRoute: () => rootRouteImport
          })
const MyStayInvoiceRoute = MyStayInvoiceRouteImport.update({
            id: '/my-stay_/invoice',path: '/my-stay/invoice',getParentRoute: () => rootRouteImport
          })
const DisplayWeatherRoute = DisplayWeatherRouteImport.update({
            id: '/display/weather',path: '/display/weather',getParentRoute: () => rootRouteImport
          })
const DisplayTidesRoute = DisplayTidesRouteImport.update({
            id: '/display/tides',path: '/display/tides',getParentRoute: () => rootRouteImport
          })
const DevTypographyRoute = DevTypographyRouteImport.update({
            id: '/dev/typography',path: '/dev/typography',getParentRoute: () => rootRouteImport
          })
const DevSeoDebugRoute = DevSeoDebugRouteImport.update({
            id: '/dev/seo-debug',path: '/dev/seo-debug',getParentRoute: () => rootRouteImport
          })
const DevSentryTestRoute = DevSentryTestRouteImport.update({
            id: '/dev/sentry-test',path: '/dev/sentry-test',getParentRoute: () => rootRouteImport
          })
const CheckoutReturnRoute = CheckoutReturnRouteImport.update({
            id: '/checkout_/return',path: '/checkout/return',getParentRoute: () => rootRouteImport
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin_/login',path: '/admin/login',getParentRoute: () => rootRouteImport
          })
const AuthenticatedReportConditionsRoute = AuthenticatedReportConditionsRouteImport.update({
            id: '/report-conditions',path: '/report-conditions',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminTeamRoute = AuthenticatedAdminTeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminStaysRoute = AuthenticatedAdminStaysRouteImport.update({
            id: '/stays',path: '/stays',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminStaffingRoute = AuthenticatedAdminStaffingRouteImport.update({
            id: '/staffing',path: '/staffing',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminReviewsRoute = AuthenticatedAdminReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminProfileRoute = AuthenticatedAdminProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPayoutsRoute = AuthenticatedAdminPayoutsRouteImport.update({
            id: '/payouts',path: '/payouts',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminInboxRoute = AuthenticatedAdminInboxRouteImport.update({
            id: '/inbox',path: '/inbox',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminGuestReviewsRoute = AuthenticatedAdminGuestReviewsRouteImport.update({
            id: '/guest-reviews',path: '/guest-reviews',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminFishingRoute = AuthenticatedAdminFishingRouteImport.update({
            id: '/fishing',path: '/fishing',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminEmailStatusRoute = AuthenticatedAdminEmailStatusRouteImport.update({
            id: '/email-status',path: '/email-status',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminDashboardRoute = AuthenticatedAdminDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminCalendarRoute = AuthenticatedAdminCalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBookingsRoute = AuthenticatedAdminBookingsRouteImport.update({
            id: '/bookings',path: '/bookings',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminActivityRoute = AuthenticatedAdminActivityRouteImport.update({
            id: '/activity',path: '/activity',getParentRoute: () => AuthenticatedAdminRoute
          })





const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminActivityRoute: AuthenticatedAdminActivityRoute,AuthenticatedAdminBookingsRoute: AuthenticatedAdminBookingsRoute,AuthenticatedAdminCalendarRoute: AuthenticatedAdminCalendarRoute,AuthenticatedAdminDashboardRoute: AuthenticatedAdminDashboardRoute,AuthenticatedAdminEmailStatusRoute: AuthenticatedAdminEmailStatusRoute,AuthenticatedAdminFishingRoute: AuthenticatedAdminFishingRoute,AuthenticatedAdminGuestReviewsRoute: AuthenticatedAdminGuestReviewsRoute,AuthenticatedAdminInboxRoute: AuthenticatedAdminInboxRoute,AuthenticatedAdminPayoutsRoute: AuthenticatedAdminPayoutsRoute,AuthenticatedAdminProfileRoute: AuthenticatedAdminProfileRoute,AuthenticatedAdminReviewsRoute: AuthenticatedAdminReviewsRoute,AuthenticatedAdminStaffingRoute: AuthenticatedAdminStaffingRoute,AuthenticatedAdminStaysRoute: AuthenticatedAdminStaysRoute,AuthenticatedAdminTeamRoute: AuthenticatedAdminTeamRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,AuthenticatedReportConditionsRoute: AuthenticatedReportConditionsRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AboutRoute: AboutRoute,AccommodationsRoute: AccommodationsRoute,AuthRoute: AuthRoute,BookingRoute: BookingRoute,CartRoute: CartRoute,CheckoutRoute: CheckoutRoute,ContactRoute: ContactRoute,FaqRoute: FaqRoute,FishSpeciesRoute: FishSpeciesRoute,FishingRoute: FishingRoute,FishingReportRoute: FishingReportRoute,GalleryRoute: GalleryRoute,LinksRoute: LinksRoute,MyStayRoute: MyStayRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,ReviewsRoute: ReviewsRoute,RlsCheckRoute: RlsCheckRoute,ShopRoute: ShopRoute,SubmitPhotoRoute: SubmitPhotoRoute,SubmitReviewRoute: SubmitReviewRoute,TermsRoute: TermsRoute,TravelTipsRoute: TravelTipsRoute,WeatherRoute: WeatherRoute,AdminLoginRoute: AdminLoginRoute,CheckoutReturnRoute: CheckoutReturnRoute,DevSentryTestRoute: DevSentryTestRoute,DevSeoDebugRoute: DevSeoDebugRoute,DevTypographyRoute: DevTypographyRoute,DisplayTidesRoute: DisplayTidesRoute,DisplayWeatherRoute: DisplayWeatherRoute,MyStayInvoiceRoute: MyStayInvoiceRoute,ShopProductIdRoute: ShopProductIdRoute,AdminIndexRoute: AdminIndexRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)